import React from 'react';
import { motion } from 'framer-motion';

const RoadmapSection = () => {
  const triggerModal = () => {
    window.dispatchEvent(new Event('openModal'));
  };

  const features = [
    {
      title: '90-Day Step-by-Step Plan:',
      description: 'Phase 1 (Foundation), Phase 2 (Analyst Skills), Phase 3 (Job Ready).'
    },
    {
      title: '5 Real-World Portfolio Projects:',
      description: 'Sales, HR Attrition, Marketing, Finance & Operations dashboards.'
    },
    {
      title: 'Resume & ATS Checklist:',
      description: 'Essential keywords and formatting to get noticed by US recruiters.'
    },
    {
      title: 'Salary Expectations (2026):',
      description: 'Detailed breakdown of Entry-Level ($55k-$75k) vs Mid-Level roles.'
    }
  ];

  return (
    <section className="py-20 bg-pbi-black border-t border-gray-800">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-16 flex flex-col md:flex-row items-center gap-12 relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-96 h-96 bg-green-500/10 blur-[120px] rounded-full"></div>

          <div className="md:w-1/3 relative group">
            <div className="bg-white text-black p-8 rounded shadow-2xl transform rotate-3 transition-transform group-hover:rotate-0 duration-500 border-8 border-black h-[450px] flex flex-col justify-between">
              <div>
                <div className="text-3xl font-black uppercase tracking-tighter mb-2">POWER BI</div>
                <div className="h-1.5 w-24 bg-pbi-yellow mb-6"></div>
                <h2 className="text-5xl font-black leading-none text-black">
                  90-DAY <br/> CAREER <br/> PLAN
                </h2>
              </div>
              <div className="text-sm font-black border-t-2 border-gray-200 pt-4 flex justify-between items-center">
                <span>AUTHOR: FATHY</span>
                <span>2026 ED.</span>
              </div>
            </div>
            <div className="absolute inset-0 bg-green-500/20 blur-3xl -z-10 group-hover:bg-green-500/40 transition-colors"></div>
          </div>

          <div className="md:w-2/3">
            <h2 className="text-4xl font-black mb-8 text-white">What's Inside The Free Guide?</h2>
            <ul className="space-y-6 mb-10">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-4">
                  <div className="mt-1 flex-shrink-0 w-6 h-6 bg-green-500/20 rounded-full flex items-center justify-center">
                    <i className="fa-solid fa-check text-green-500 text-xs" />
                  </div>
                  <span className="text-gray-300 text-lg">
                    <strong className="text-white font-bold">{feature.title}</strong> {feature.description}
                  </span>
                </li>
              ))}
            </ul>

            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-green-600 hover:bg-green-700 text-white font-black py-5 px-12 rounded-2xl shadow-2xl flex items-center gap-4 transition-all duration-300 text-xl"
              onClick={triggerModal}
            >
              Get Your Roadmap Now
              <i className="fa-solid fa-arrow-right" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RoadmapSection;